(ns common.transaction-process.templates.capman.hooks
  "CapMan-namespaced hook implementations, registered by keyword into the shared
   hook registry (`common.transaction-process.hooks`). The engine invokes these
   generically by keyword and never imports this namespace — this is where the
   irreducible CapMan-specific Clojure logic lives, isolated from the engine."
  (:require
   [common.schema.entities.transaction-process :as tp-schema]
   [common.transaction-process.templates.capman.reservation-prefill :as reservation-prefill]
   [common.util :as cu]))

(defn reservation-prefill-hook
  "`:hook/prefill` — seed a PM-approval decision's investment-reservation rows
   from the preparation-stage amounts, matching configured category labels to
   reservation-type titles (the deliberately one-off CapMan label matching). Owns
   its own CapMan config (`reservation-mappings`); the engine injects only
   the rich runtime context (session-resolved data) and reads nothing global."
  [{:keys [process-entity reservation-types create-temp-id default-currency]}]
  (reservation-prefill/build-prefill-reservations
   {:reservation-mappings reservation-prefill/reservation-mappings
    :process-entity    process-entity
    :reservation-types reservation-types
    :create-temp-id    create-temp-id
    :default-currency  default-currency}))

(defn seed-ic-decision-needed
  "`:hook/transform-write` — when the anticipated IC decision date is first set,
   seed `:transaction-process/ic-decision-needed` to Needed. One-time seed, not a
   binding: it only fires while the field is still unset and the update doesn't set
   it explicitly, so a later clear of the date won't un-need IC and an explicit
   user choice always wins. After seeding, the persisted field is the single source
   of truth (no read-time derivation)."
  [{:keys [prev updates]}]
  (if (and (some? (:transaction-process/anticipated-ic-decision-date updates))
           (not (cu/blank-value? (:transaction-process/anticipated-ic-decision-date updates)))
           (not (contains? updates :transaction-process/ic-decision-needed))
           (nil? (:transaction-process/ic-decision-needed prev)))
    (assoc updates :transaction-process/ic-decision-needed tp-schema/needed-value)
    updates))

(def hooks
  "hook-key -> fn. Merged into the shared registry."
  {:capman.tp/reservation-prefill   reservation-prefill-hook
   :capman.tp/seed-ic-decision-needed seed-ic-decision-needed})
